<template>
  <div class="video">
    <iframe width="560" height="315" :src="embedUrl" frameborder="0" allowfullscreen class="video__iframe"></iframe>
  </div>
</template>

<script>
  export default {
    props: {
      video: String,
      source: String
    },
    computed: {
      embedUrl() {
        if (this.source == 'vimeo') {
          let vimeoUrl = this.video.split('/');
          return '//player.vimeo.com/video/' + vimeoUrl[3];
        } else {
          let regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
          let match = this.video.match(regExp);
          let id = (match&&match[2].length==11)? match[2] : false;
          return '//www.youtube.com/embed/' + id;

        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'foundation-sites/scss/foundation.scss';
  @import '@/assets/scss/_settings';
  .video {
    margin: vw-relative(20 0, 320);
    @include breakpoint(medium) {
      margin: vw-relative(30 0);
    }
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
    width: 100%;
    &__iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>
